import { useMenuController } from "../Menu.controller";
import React from "react";
import type MenuProperties from "../Menu.properties.ts";
import MenuEnum from "../Menu.enum.ts";
import MenuMarketManagementView from "./Menu.MarketManagement.view.tsx";
import MenuAdministrationView from "./MenuAdministrationView.tsx";

export default function MenuDesktopView(props: MenuProperties) {
  const { loading } = useMenuController();

  return (
    <>
      {!loading && props.menu === MenuEnum.MarketManagement && (
        <MenuMarketManagementView />
      )}

      {!loading && props.menu === MenuEnum.Administration && (
        <MenuAdministrationView />
      )}
    </>
  );
}
